import { PlusCircleOutlined } from '@ant-design/icons';
import { Button, Grid, message, Popconfirm, Space, Switch, Table } from 'antd';
import { Column } from 'components';
import {
  StyledTableHeader,
  StyledTableWrapper,
} from 'components/table/table.styled';
import { useCategoryUserStatus } from 'features/assigned-clients/use-cases/category-user-status';
import {
  SubCategoryFilterFormValuesPaginated,
  SubCategoryFormFilterValues,
} from 'features/master-management/components/filter-field/type';
import { useGetClientsSubCetgoryList } from 'features/new-clients/use-cases/get-clients-subcategory';
import { usePaginationParams } from 'hooks';
import { FilePenLine, Trash2 } from 'lucide-react';
import { Fragment, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { SubCategoryClientsFilterForm } from './form-filter/subCategory-client-filter-form';
import { AddEditSubCategoryUserModal } from './modal/add-edit-subCategory';

const { useBreakpoint } = Grid;

export const AssignSubCategory = () => {
  const screens = useBreakpoint();
  const { id } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState('');
  const assignvalue: any = localStorage.getItem('activeTabAssign');
  const getInitialFilterValues: SubCategoryFormFilterValues = {
    SubCategoryName: undefined,
    CategoryId: undefined,
  };
  const [loadingStatus, setLoadingStatus] = useState<{
    [key: number]: boolean;
  }>({});
  const { mutate: CategoryUserStatus, isLoading: globalStatusLoading } =
    useCategoryUserStatus();
  const { params, updateParams, resetPage } =
    usePaginationParams<SubCategoryFilterFormValuesPaginated>({
      PageIndex: 1,
      RecordPerPage: 10,
      ...getInitialFilterValues,
    });
  const {
    data: dataList,
    isFetching,
    refetch,
  } = useGetClientsSubCetgoryList({
    ...params,
    CompanyId: id,
  });
  const formId = 'role-filters-form';
  const handleOpenEdit = (item: any) => {
    setEditData(item);
    setShowModal(true);
  };
  const handleFiltersChange = (values: SubCategoryFormFilterValues) => {
    updateParams(values);
    resetPage();
  };
  const onChangeDelete = (record: any) => {
    const CetgoryDelete = {
      flag: 'DELETE',
      companyId: id, // Assuming `id` is defined elsewhere in your code
      seviceId: record.id || '', // Assuming `serviceId` is a property in `record`
      status: record.status, // Status is passed as a parameter
    };
    CategoryUserStatus(CetgoryDelete, {
      onSuccess: (data: any) => {
        if (data?.rs == 1) {
          message.success('SubCategory Delete successfully');
        } else {
          message.error(
            'Cannot delete Subcategory as it is linked to a document',
          );
        }
      },
    }); // Call mutate with data.id
  };
  const handleStatusChange = (record: any, checked: boolean) => {
    const formData = {
      flag: 'UPDATE',
      companyId: id,
      seviceId: record.id || '', // Use value as the service ID
      status: checked, // Send the checked value (true or false) as the updated status
    };
    // Update loading status for the record while processing
    setLoadingStatus((prev) => ({ ...prev, [record.id]: true }));
    // Call the mutate function (API call for status update)
    CategoryUserStatus(formData, {
      onSuccess: (data) => {
        setLoadingStatus((prev) => ({ ...prev, [record.id]: false }));
        if (data?.rs == 1) {
          message.success('Status Changed successfully');
        } else {
          message.error(data?.rm);
        }
      },
      onError: () => {
        setLoadingStatus((prev) => ({ ...prev, [record.id]: false }));
      },
    });
  };
  useEffect(() => {
    if (assignvalue == 4) {
      refetch();
    }
  }, [assignvalue]);

  return (
    <Fragment>
      <SubCategoryClientsFilterForm
        formId={formId}
        handleFilter={handleFiltersChange}
        initialValues={getInitialFilterValues}
      />
      <StyledTableWrapper className='card grid_secton'>
        <StyledTableHeader className='gs_head'>
          <h3>
            Sub Categories List
            {/* <span>{dataList?.length > 0 ? dataList[0].totalRecords : '0'}</span> */}
          </h3>

          <div className='buttongroup'>
            <Button
              icon={<PlusCircleOutlined />}
              style={{ backgroundColor: '#223666', color: 'white' }}
              onClick={() => {
                setEditData(null as any);
                setShowModal(true);
              }}
            >
              {screens.lg ? <>Add New Sub Category</> : <>Add New</>}
            </Button>
            {showModal && (
              <AddEditSubCategoryUserModal
                onClose={() => setShowModal(false)}
                editData={editData}
                setEditData={setEditData}
                refetch={refetch}
              />
            )}
          </div>
        </StyledTableHeader>
        <div className='cstmtblbx w-full'>
          <div className='cstm_table'>
            <Table
              loading={isFetching}
              dataSource={dataList?.rc as any}
              rowKey='id'
              // onChange={handleTableChange}
              // pagination={{
              //     current: tableParams.PageIndex,
              //     defaultPageSize: tableParams.RecordPerPage,
              //     total: 10,
              // }}
            >
              <Column
                width={'125px'}
                title={'Sr No'}
                render={(_, __, index) => {
                  return index + 1;
                }}
              />
              <Column title={'Category Name'} dataIndex={'categoryName'} />
              <Column
                title={'Sub Category Name'}
                dataIndex={'subCategoryName'}
              />

              <Column
                width={'125px'}
                title={'Status'}
                dataIndex={'status'}
                render={(_, record: any) => (
                  <span
                    style={{
                      color: record.isActive === true ? '#155724' : 'red', // Green for "Active", Red for "Inactive"
                    }}
                  >
                    {record?.isActive == true ? 'Active' : 'InActive'}
                  </span>
                )}
              />
              <Column
                width='135px'
                title={'Action'}
                dataIndex={'Id'}
                render={(_, record: any) => (
                  <Space className='grdbtngroup'>
                    {!record?.isDefault && (
                      <Button
                        className='btn'
                        type='link'
                        onClick={() => {
                          setShowModal(true);
                          handleOpenEdit(record);
                        }}
                      >
                        <FilePenLine height={16} />
                      </Button>
                    )}
                    <Popconfirm
                      title='Delete the SubCategory'
                      description='Are you sure to delete this SubCategory?'
                      okText='Yes'
                      cancelText='No'
                      onConfirm={() => onChangeDelete(record)}
                    >
                      <Button className='btn' type='link'>
                        <Trash2 stroke='#E04343' height={16} />
                      </Button>
                    </Popconfirm>

                    <Switch
                      disabled={loadingStatus[record.id] || globalStatusLoading} // Disable if loading
                      loading={loadingStatus[record.id]} // Show loading for specific category
                      onChange={(checked) =>
                        handleStatusChange(record, checked)
                      } // Pass checked value to the handler
                      checked={record.isActive} // Ensure this reflects the actual status of the record
                    />
                  </Space>
                )}
              />
            </Table>
          </div>
        </div>
      </StyledTableWrapper>
    </Fragment>
  );
};
